/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_IdentityInputs */

const cs_enum_identity = /** @type {(inputs: Enum_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identita`)
};

const en_enum_identity = /** @type {(inputs: Enum_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identity`)
};

/**
* | output |
* | --- |
* | "Identity" |
*
* @param {Enum_IdentityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_identity = /** @type {((inputs?: Enum_IdentityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_IdentityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_identity(inputs)
	return cs_enum_identity(inputs)
});